import { render, staticRenderFns } from "./PageLost.vue?vue&type=template&id=4a317d03&scoped=true&"
import script from "./PageLost.vue?vue&type=script&lang=js&"
export * from "./PageLost.vue?vue&type=script&lang=js&"
import style0 from "./PageLost.vue?vue&type=style&index=0&id=4a317d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a317d03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a317d03')) {
      api.createRecord('4a317d03', component.options)
    } else {
      api.reload('4a317d03', component.options)
    }
    module.hot.accept("./PageLost.vue?vue&type=template&id=4a317d03&scoped=true&", function () {
      api.rerender('4a317d03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageLost.vue"
export default component.exports